import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2j1b52vu: FaireBrandEntity = {
  token: "b_2j1b52vu",
  type: "brand",
  name: "garb2ART",
  avatarUrl:
    "https://cdn.faire.com/fastly/37914f51f44dcd5b7f2e8325cbc7db34ea2b6fabd5094b8c6f86e3ea54674429.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/43c3155f674e9e338b750a7fcc5513bea0d79b3f963a6b15533035d7a6c68324.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/37914f51f44dcd5b7f2e8325cbc7db34ea2b6fabd5094b8c6f86e3ea54674429.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/43c3155f674e9e338b750a7fcc5513bea0d79b3f963a6b15533035d7a6c68324.jpeg",
  location: "Columbus, IN, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 496,
  isInsider: true,
  description:
    "After months of turning recyclable items into art pieces and making lip gloss for family and friends, my life changed in a matter of weeks. Between facing a scare with cancer and the death of my father I decided to follow my dreams. I had started getting serious about selling lip gloss in my spare time, while still working full time and raising five children. It was a now or never moment to take something I loved and nurture it into a successful business.\n\nIn 2014, after a full year of making gloss I made the decision to quit my job and devote my full focus to my business, garb2ART LLC. We have expanded our line of products from a line of lip gloss to include bath bombs, milk bath, soaps, and whatever else we feel like whipping up. We also continue to be an earth friendly company by using recycled, recyclable, reusable, and minimum waste packaging.  This has helped us kept over 9 tons of waste out of USA landfills.  All product are handmade in the USA and we are a 100% Female Owned Business.\n\nI hope you love using our products as much as we love making them!\n\nDawn Andrews\nFounder and President of garb2ART",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:44.988Z",
    importedBy: "entity-db-cli",
  },
};
